import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page bg-background min-h-screen">
      <Navigation />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            About{' '}
            <span className="bg-gradient-to-r from-[#FF56A5] via-[#E852FF] to-[#9F44F2] bg-clip-text text-transparent">
              Lifelike Agents
            </span>
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Revolutionizing communication through AI-powered conversations
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-1">
            <div className="bg-gradient-to-br from-[#FF56A5]/20 via-[#E852FF]/20 to-[#9F44F2]/20 rounded-2xl p-8">
              <div className="space-y-12 text-gray-300">
                {/* Mission Section */}
                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">Our Mission</h2>
                  <p className="text-lg">
                    To transform the way businesses communicate by leveraging cutting-edge AI technology,
                    making meaningful conversations scalable and accessible to everyone.
                  </p>
                </section>

                {/* Values Section */}
                <section>
                  <h2 className="text-2xl font-semibold text-white mb-6">Our Values</h2>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="text-center">
                      <div className="flex items-center justify-center h-12 w-12 rounded-xl bg-gradient-to-br from-[#FF56A5]/20 to-[#E852FF]/20 mx-auto mb-4 border border-[#FF56A5]/20">
                        <svg className="h-6 w-6 text-[#FF56A5]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                      </div>
                      <h3 className="text-lg font-medium text-white mb-2">Innovation</h3>
                      <p className="text-gray-400">
                        Pushing the boundaries of what's possible with AI communication
                      </p>
                    </div>

                    <div className="text-center">
                      <div className="flex items-center justify-center h-12 w-12 rounded-xl bg-gradient-to-br from-[#E852FF]/20 to-[#9F44F2]/20 mx-auto mb-4 border border-[#E852FF]/20">
                        <svg className="h-6 w-6 text-[#E852FF]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                      </div>
                      <h3 className="text-lg font-medium text-white mb-2">Trust & Security</h3>
                      <p className="text-gray-400">
                        Ensuring the highest standards of data protection and privacy
                      </p>
                    </div>

                    <div className="text-center">
                      <div className="flex items-center justify-center h-12 w-12 rounded-xl bg-gradient-to-br from-[#9F44F2]/20 to-[#FF56A5]/20 mx-auto mb-4 border border-[#9F44F2]/20">
                        <svg className="h-6 w-6 text-[#9F44F2]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                        </svg>
                      </div>
                      <h3 className="text-lg font-medium text-white mb-2">Accessibility</h3>
                      <p className="text-gray-400">
                        Making advanced AI communication tools available to businesses of all sizes
                      </p>
                    </div>
                  </div>
                </section>

                {/* Team Section */}
                <section>
                  <h2 className="text-2xl font-semibold text-white mb-4">Our Team</h2>
                  <p className="text-lg">
                    A dedicated group of innovators, engineers, and problem solvers working to create
                    the future of communication.
                  </p>
                </section>

                {/* Contact Section */}
                <section className="text-center">
                  <h2 className="text-2xl font-semibold text-white mb-4">Get in Touch</h2>
                  <p className="text-lg mb-6">
                    Have questions about Lifelike Agents? We'd love to hear from you.
                  </p>
                  <Link
                    to="/request-demo"
                    className="inline-flex items-center px-8 py-3 border border-transparent text-base font-medium rounded-full text-white bg-gradient-to-r from-[#FF56A5] via-[#E852FF] to-[#9F44F2] hover:from-[#FF56A5]/90 hover:via-[#E852FF]/90 hover:to-[#9F44F2]/90 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                  >
                    Request a Demo
                  </Link>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs; 